import { createClient } from '@supabase/supabase-js';
import { supabaseFetch } from './gateway-retry';

/**
 * Service-role Supabase client — bypasses RLS.
 * Only use in server-side cron jobs and internal pipelines, never in user-facing routes.
 */
export function createAdminClient() {
  const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
  const key = process.env.SUPABASE_SERVICE_ROLE_KEY;

  if (!url || !key) {
    throw new Error('Missing SUPABASE_SERVICE_ROLE_KEY or NEXT_PUBLIC_SUPABASE_URL');
  }

  return createClient(url, key, {
    auth: { persistSession: false },
    // A read that gets Cloudflare's 502 page is sent once more; see gateway-retry.ts.
    global: { fetch: supabaseFetch },
  });
}
